import { render, staticRenderFns } from "./rekap_objek_pajak.vue?vue&type=template&id=57884df3&"
import script from "./rekap_objek_pajak.vue?vue&type=script&lang=js&"
export * from "./rekap_objek_pajak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports